module.exports = __webpack_public_path__ + "img/conocenos.aabac626.jpg";